<template>
	<el-dialog :modelValue="open" @update:modelValue="$emit('update:open', $event)" :title="'Änderungen verwerfen?'" align-center>
		<el-alert
			:title="'Sind Sie sicher? Wenn Sie diese Seite verlassen ohne zu speichern, werden Ihre Änderungen verloren und können nicht wiederhergestellt werden. '"
			type="error"
			:closable="false"
			effect="dark"
			show-icon
		/>

		<template #footer>
			<div class="button-panel">
				<TheButton
					type="primary"
					@buttonclick="
						$emit('cancel');
						$emit('update:open', false);
					"
				>
					Ohne Speichern verlassen
				</TheButton>
				<TheButton
					type="default"
					@buttonclick="
						$emit('save');
						$emit('update:open', false);
					"
				>
					Speichern und verlassen
				</TheButton>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import TheButton from '../TheButton.vue';

export default defineComponent({
	name: 'DialogLeavePage',
	data() {
		return {};
	},
	components: {
		TheButton,
	},
	props: {
		open: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['cancel', 'save', 'update:open'],
	computed: {},
	methods: {},
	mounted() {},
});
</script>

<style lang="scss"></style>
